(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('GlobalMessageViewed', GlobalMessageViewed);

    GlobalMessageViewed.$inject = ['$resource'];

    function GlobalMessageViewed ($resource) {
        var resourceUrl =  'api/global-message-vieweds/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
